import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import GenericDrugList from "./GenericDrugList.js";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew.js";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner.js";
import { errorAlert } from "../../../common/components/Toasts/CustomToasts.js";
import {
  getAllDoctorBilBankPaymentlist,
  getAllDoctorBillist,
  getAllInventoryPharmacylist,
  getAllIPDList,
  getAllOPDCancellationlist,
  getAllOPDList,
  getfunctionalityDropdown,
  getSubfunctionalityDropdown,
} from "../../services/XMLGenerationForTallyService/XMLGenerationForTallyService";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton.js";

const TallyInterfaceModal = (props) => {
  const { control, setValue, watch } = useForm({
    defaultValues: { fromDate: new Date(), toDate: new Date() },
  });
  const watchStartDate = watch("fromDate");
  const watchEndDate = watch("toDate");
  const [selectedFunctionality, setSelectedFunctionality] = useState(null);
  const [selectedSubfunctionalities, setSelectedSubfunctionalities] = useState(
    {}
  );
  const [listingData, setListingData] = useState([]);
  const [functionality, setFunctionality] = useState([]);
  const [subfunctionality, setSubFunctionality] = useState([]);
  const [listingObject, setListingObject] = useState({
    startDate: null,
    endDate: null,
  });
  const PrintRef = useRef();
  const { openTallyData, setOpenTallyData } = props;
  const [spinner, showSpinner] = React.useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setselectedRow] = useState([]);
  useEffect(() => {
    getfunctionalityDropdown()
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setFunctionality(res.result);
          console.log(res.result, "ddd");
        }
      })
      .catch((error) => errorAlert(error.message));
  }, []);
  useEffect(() => {
    if (!selectedFunctionality) return;
    getSubfunctionalityDropdown(selectedFunctionality?.id)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200 || res.statusCode === 204) {
          if (Array.isArray(res.result) && res.result.length > 0) {
            setSubFunctionality(res.result);
          } else {
            setSubFunctionality([
              {
                Functionality: selectedFunctionality?.label,
              },
            ]);
          }
        } else {
          errorAlert(`Unexpected response: ${res.message}`);
        }
      })
      .catch((error) => {
        console.error("Error fetching subfunctionality:", error);
        errorAlert(error.message || "Failed to fetch subfunctionalities.");
      });
  }, [selectedFunctionality]);
  useEffect(() => {
    const fromDate = watch("fromDate");
    const toDate = watch("toDate");
    const areDatesValid = fromDate != null && toDate != null;

    if (selectedRow !== null && areDatesValid) {
      const startDate = fromDate?.toISOString?.().split("T")[0] || null;
      const endDate = toDate?.toISOString?.().split("T")[0] || null;

      const newListingObject = {
        startDate,
        endDate,
      };

      setListingObject(newListingObject);
      setListingData([]);

      // ---------------- OPD ----------------
      if (selectedFunctionality?.id === 1) {
        showSpinner(true);
        getAllOPDList(newListingObject)
          .then((response) => response.data)
          .then((res) => {
            if (res.statusCode === 200 || res.statusCode === 204) {
              setListingData(res.result);
            }
            showSpinner(false);
          })
          .catch((error) => {
            console.log(error);
            showSpinner(false);
          });

        // ---------------- IPD ----------------
      } else if (selectedFunctionality?.id === 3) {
        const tempObj = {
          ...newListingObject,
          reportType: selectedRow?.id,
        };

        showSpinner(true);
        getAllIPDList(tempObj)
          .then((response) => response.data)
          .then((res) => {
            if (res.statusCode === 200 || res.statusCode === 204) {
              setListingData(res.result);
            }
            showSpinner(false);
          })
          .catch((error) => {
            console.log(error);
            showSpinner(false);
          });

        // ---------------- Doctor Bill ----------------
      } else if (selectedFunctionality?.id === 4) {
        const tempObj = {
          ...newListingObject,
          reportType: selectedRow?.id,
        };

        if (selectedRow?.value === 16 || selectedRow?.value === 18) {
          showSpinner(true);
          getAllDoctorBillist(tempObj)
            .then((response) => response.data)
            .then((res) => {
              if (res.statusCode === 200 || res.statusCode === 204) {
                setListingData(res.result);
              }
              showSpinner(false);
            })
            .catch((error) => {
              console.log(error);
              showSpinner(false);
            });
        } else if (selectedRow?.value === 17 || selectedRow?.value === 19) {
          showSpinner(true);
          getAllDoctorBilBankPaymentlist(tempObj)
            .then((response) => response.data)
            .then((res) => {
              if (res.statusCode === 200 || res.statusCode === 204) {
                setListingData(res.result);
              }
              showSpinner(false);
            })
            .catch((error) => {
              console.log(error);
              showSpinner(false);
            });
        }

        // ---------------- OPD Cancellation ----------------
      } else if (selectedFunctionality?.id === 5) {
        showSpinner(true);
        getAllOPDCancellationlist(newListingObject)
          .then((response) => response.data)
          .then((res) => {
            if (res.statusCode === 200 || res.statusCode === 204) {
              setListingData(res.result);
            }
            showSpinner(false);
          })
          .catch((error) => {
            console.log(error);
            showSpinner(false);
          });

        // ---------------- Inventory (Pharmacy) ----------------
      } else if (selectedFunctionality?.id === 2) {
        const tempObj = {
          ...newListingObject,
          reportType: selectedRow?.id,
        };

        showSpinner(true);
        getAllInventoryPharmacylist(tempObj)
          .then((response) => response.data)
          .then((res) => {
            if (res.statusCode === 200 || res.statusCode === 204) {
              setListingData(res.result);
            }
            showSpinner(false);
          })
          .catch((error) => {
            console.log(error);
            showSpinner(false);
          });

        // ---------------- Pharmacy ----------------
      } else if (selectedFunctionality?.id === 1) {
        setListingData([]);
      }
    } else {
      setListingData([]);
    }
  }, [selectedRow, watch("fromDate"), watch("toDate"), selectedFunctionality]);
  // useEffect(() => {
  //   const areDatesValid = watch("fromDate") != null && watch("toDate") != null;
  //   if (selectedRow !== null && areDatesValid) {
  //     setListingObject({
  //       startDate: watch("fromDate")?.toISOString?.().split("T")[0] || null,
  //       endDate: watch("toDate")?.toISOString?.().split("T")[0] || null,
  //     });

  //     setListingData([]);
  //     if (selectedRow?.Functionality === "OPD") {
  //       setListingData([]);
  //       showSpinner(true);
  //       getAllOPDList(listingObject)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           if (res.statusCode === 200 || res.statusCode === 204) {
  //             setListingData(res.result);
  //             showSpinner(false);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           showSpinner(false);
  //         });
  //     } else if (selectedFunctionality?.label === "IPD") {
  //       let tempObj = { ...listingObject, reportType: selectedRow?.id };
  //       showSpinner(true);
  //       getAllIPDList(tempObj)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           if (res.statusCode === 200 || res.statusCode === 204) {
  //             setListingData(res.result);
  //             showSpinner(false);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           showSpinner(false);
  //         });
  //     } else if (selectedFunctionality?.label === "Doctor Bill") {
  //       let tempObj = { ...listingObject, reportType: selectedRow?.id };
  //       if (selectedRow?.value === 16 || selectedRow?.value === 18) {
  //         showSpinner(true);
  //         getAllDoctorBillist(tempObj)
  //           .then((response) => response.data)
  //           .then((res) => {
  //             if (res.statusCode === 200 || res.statusCode === 204) {
  //               setListingData(res.result);
  //               showSpinner(false);
  //             }
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //             showSpinner(false);
  //           });
  //       } else if (selectedRow?.value === 17 || selectedRow?.value === 19) {
  //         showSpinner(true);
  //         getAllDoctorBilBankPaymentlist(tempObj)
  //           .then((response) => response.data)
  //           .then((res) => {
  //             if (res.statusCode === 200 || res.statusCode === 204) {
  //               setListingData(res.result);
  //               showSpinner(false);
  //             }
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //             showSpinner(false);
  //           });
  //       }
  //     } else if (selectedRow?.Functionality === "OPD Cancellation") {
  //       showSpinner(true);
  //       getAllOPDCancellationlist(listingObject)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           if (res.statusCode === 200 || res.statusCode === 204) {
  //             setListingData(res.result);
  //             showSpinner(false);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           showSpinner(false);
  //         });
  //     } else if (selectedFunctionality?.label === "Inventory (Pharmacy)") {
  //       let tempObj = { ...listingObject, reportType: selectedRow?.id };

  //       showSpinner(true);
  //       getAllInventoryPharmacylist(tempObj)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           if (res.statusCode === 200 || res.statusCode === 204) {
  //             setListingData(res.result);
  //             showSpinner(false);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           showSpinner(false);
  //         });
  //     } else if (selectedRow?.Functionality === "Pharmacy") {
  //       setListingData([]);
  //     }
  //   } else {
  //     setListingData([]);
  //   }
  // }, [selectedRow, watch("fromDate"), watch("toDate"), selectedFunctionality]);
  // console.log("llll", listingData);
  return (
    <>
      <Modal open={openTallyData}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "90%",
            minHeight: "50%",
            maxHeight: "95%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 20,
            overflowY: "auto",
            p: 1,
          }}
          className="w-[97%] md:h-[95%] overflow-y-scroll"
        >
          <div className="w-full flex justify-between items-center  -mt-1">
            <h2 className="text-lg font-semibold">Tally Interface</h2>
            <button
              type="button"
              onClick={() => {
                setOpenTallyData(false);
              }}
            >
              <CancelPresentationIconButton />
            </button>
          </div>
          {functionality.length > 0 && (
            <div className="flex items-center flex-wrap gap-2 mt-2">
              <div className="w-[127px] flex justify-between items-center">
                <p className="text-sm font-medium">Functionality </p>
                <p>:</p>
              </div>
              {functionality.length > 0 &&
                functionality.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className={`px-4 py-2 rounded  shadow-sm text-[12px] font-semibold transition-all duration-200
        ${
          selectedFunctionality?.label === item.label
            ? "bg-customBlue text-white "
            : "bg-white border-[1px] border-customBlue  text-customBlue"
        }`}
                    onClick={() => {
                      setSubFunctionality([]);
                      setSelectedFunctionality(
                        selectedFunctionality?.label === item?.label
                          ? null
                          : item
                      );
                    }}
                  >
                    {item.label}
                  </button>
                ))}
            </div>
          )}

          <div className="flex space-x-2 w-[50%] mt-3">
            <DatePickerField
              inputFormat={"dd-MM-yyyy"}
              control={control}
              name="fromDate"
              label="From Date"
              // defaultValue={new Date()}
            />
            <DatePickerField
              inputFormat={"dd-MM-yyyy"}
              control={control}
              name="toDate"
              label="To Date"
              // defaultValue={new Date()}
            />
            {/* <CommonButton
              className="bg-customBlue text-white"
              searchIcon={true}
            /> */}
          </div>
          <form className="space-y-1 flex  gap-2">
            <div className="w-[25%] pt-2.5 h-[70%]">
              {subfunctionality.length > 0 && (
                <GenericDrugList
                  dataResult={subfunctionality}
                  setSelectedGenericDrug={(row) => {
                    setselectedRow(row);
                    console.log("Selected row: ", row);
                  }}
                  close={() => {}}
                  removeHeaders={"id"}
                />
              )}
            </div>

            <div className="w-[75%] h-full">
              {spinner ? (
                <div className="grid justify-center items-center h-[60vh]">
                  <LoadingSpinner />
                </div>
              ) : null}
              {listingData?.records?.length > 0 ? (
                <>
                  <CommonDynamicTableNew
                    highlightRow={false}
                    dataResult={listingData?.records}
                    count={listingData.length}
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                    page={page}
                    setPage={setPage}
                    tableHeading={"Tally Interface"}
                    removeHeaders={["totalDr", "totalCr"]}
                    tableClass={"h-[65vh] overflow-scroll"}
                    //   renderActions={renderActions}
                  />
                  <div className="flex gap-10 justify-end items-center px-4 py-2 bg-gray-100 rounded-md shadow-sm border border-gray-300 text-sm font-medium text-gray-700">
                    <div className="flex items-center space-x-2">
                      <span className="text-gray-500">Total Dr:</span>
                      <span className=" font-semibold">
                        {listingData?.totalCR}
                      </span>
                    </div>{" "}
                    <div className="flex items-center space-x-2">
                      <span className="text-gray-500">Total Cr:</span>
                      <span className=" font-semibold">
                        {listingData?.totalDR}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <div className=" h-[60vh]">
                  {!spinner && (
                    <div className="flex justify-center items-center h-full  mt-20 rounded-md ">
                      <h3 className="flex justify-center h-full items-center font-bold text-gray-600">
                        No Records Found...
                      </h3>
                    </div>
                  )}
                </div>
              )}
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default TallyInterfaceModal;
